export const URL_NAME = 'Bargain Spark';
export const APP_URL = 'https://www.bargain-spark.com';
export const APP_VERSION = 1.0;
